import { render, staticRenderFns } from "./EditCartomakStockSupplierConfigComponent.vue?vue&type=template&id=0bdbc630&"
import script from "./EditCartomakStockSupplierConfigComponent.vue?vue&type=script&lang=js&"
export * from "./EditCartomakStockSupplierConfigComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports